import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

const useUpdateQueryParams = () => {
  const {
    search,
  } = useLocation();

  const queryParams = queryString.parse(search);

  const getUpdatedQueryParams = (updatedQueryParams) => {
    Object.keys(updatedQueryParams).forEach((key) => {
      const value = updatedQueryParams[key];
      if (value === undefined) delete queryParams[key];
      else queryParams[key] = value;
    });

    return `?${queryString.stringify(queryParams)}`;
  };
  return [queryParams, getUpdatedQueryParams];
};

export default useUpdateQueryParams;
